import React from "react";


export default {
  a: props => <a className="link text-black" {...props}/>
}
